import { styled } from "@mui/material/styles";
import { useColors } from "../../../../Context/ColorsContext";
import { MediaQuerys } from "../../../../styles/GlobalStyle";

const { desktop } = MediaQuerys;

export const Container = styled('div')(({theme}) => {
  return {
    display: 'flex',
    width: '900px',
    height: 'auto',
    maxHeight: '80vh',
    flexDirection: 'column',
    [theme.breakpoints.up('xs')]: {
      width: '90vw',
    },
    [theme.breakpoints.up('sm')]: {
      width: '80vw',
    },
    [theme.breakpoints.up('md')]: {
      width: '70vw',
    },
    [theme.breakpoints.up('lg')]: {
      width: '800px',
    },
    [theme.breakpoints.up('xl')]: {
      width: '900px',
    },
  }
})

export const Header = styled('div')(() => {
  const { colors } = useColors();
  return {
    display: 'flex',
    background: colors.white,
    color: colors.detailTextColor,
    width: '100%',
    height: 'fit-content',
    borderRadius:'10px 10px 0 0',
    padding:'16px',
    textTransform:'uppercase',
    fontWeight:600,
    [desktop]: {
      fontSize:'0.95rem',
    }
  }
})

export const Body = styled('div')(() => {
  const { colors } = useColors();
  return {
    display: 'flex',
    flexDirection:'column',
    flex:'1',
    width: '100%',
    overflowY: 'auto',
    background: colors.white,
    paddingBottom: '1rem',
  }
})

export const Footer = styled('div')(() => {
  const { colors } = useColors();
  return {
    display: 'flex',
    background: colors.white,
    width: '100%',
    height: 'fit-content',
    borderRadius:'0 0 10px 10px',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: '8px 16px',
    margin: 'auto'
  }
})

export const SectionRight = styled('section')(() => ({
  display: 'flex',
}))

export const Spacer = styled('section')(() => ({
  padding: '0.5rem',
}))